import React from "react";
import { SideMenu, DateRangePicker, Model } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import ShareIcon from "@mui/icons-material/Share";
import "./lesson-plan.css";
import Checkbox from "@mui/material/Checkbox";
import ProfileImage from "./../../../assets/images/ProfileImage.png";
const label = { inputProps: { "aria-label": "Checkbox demo" } };
const LessonPlan = () => {
  const navigate = useNavigate();
  // Share Handler
  const [shareModel, setShareModel] = React.useState(false);
  const [shareLoading, setShareLoading] = React.useState(false);
  const ShareHandler = () => {
    setShareLoading(true);
    setTimeout(() => {
      setShareModel(false);
      setShareLoading(false);
    }, 2000);
  };

  const [shareList, setShareList] = React.useState([
    {
      name: "Samantha aryton",
      select: false,
    },
    {
      name: "Johan smith",
      select: false,
    },

    {
      name: "Nataliya law",
      select: false,
    },
    {
      name: "Jezing",
      select: false,
    },
    {
      name: "Samantha aryton",
      select: false,
    },
    {
      name: "Johan smith",
      select: false,
    },
  ]);
  const TableData = [
    {
      date: "Jan 04, 2022	",
      title: "salary",
      subjectName: "Maths",
      topic: "Lorem ipsum",
      topicDescription: "Lorem ipsum dolor sit a...",
      time: "Daily",
    },
    {
      date: "Jan 04, 2022	",
      title: "salary",
      subjectName: "Maths",
      topic: "Lorem ipsum",
      topicDescription: "Lorem ipsum dolor sit a...",
      time: "Daily",
    },
    {
      date: "Jan 04, 2022	",
      title: "salary",
      subjectName: "Maths",
      topic: "Lorem ipsum",
      topicDescription: "Lorem ipsum dolor sit a...",
      time: "Weekly",
    },
    {
      date: "Jan 04, 2022	",
      title: "salary",
      subjectName: "Maths",
      topic: "Lorem ipsum",
      topicDescription: "Lorem ipsum dolor sit a...",
      time: "Weekly",
    },
    {
      date: "Jan 04, 2022	",
      title: "salary",
      subjectName: "Maths",
      topic: "Lorem ipsum",
      topicDescription: "Lorem ipsum dolor sit a...",
      time: "Weekly",
    },
    {
      date: "Jan 04, 2022	",
      title: "salary",
      subjectName: "Maths",
      topic: "Lorem ipsum",
      topicDescription: "Lorem ipsum dolor sit a...",
      time: "Monthly",
    },
    {
      date: "Jan 04, 2022	",
      title: "salary",
      subjectName: "Maths",
      topic: "Lorem ipsum",
      topicDescription: "Lorem ipsum dolor sit a...",
      time: "Weekly",
    },
    {
      date: "Jan 04, 2022	",
      title: "salary",
      subjectName: "Maths",
      topic: "Lorem ipsum",
      topicDescription: "Lorem ipsum dolor sit a...",
      time: "Weekly",
    },
    {
      date: "Jan 04, 2022	",
      title: "salary",
      subjectName: "Maths",
      topic: "Lorem ipsum",
      topicDescription: "Lorem ipsum dolor sit a...",
      time: "Monthly",
    },
  ];
  return (
    <SideMenu>
      <div className="page-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={8} lg={7} md={7} sm={4} xs={12}></Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={4}>
              <Button className="header-button" variant="text">
                <p className="page-header-button-text">Download</p>
              </Button>
            </Grid>
            <Grid item xl={2} lg={3} md={3} sm={4} xs={8}>
              <Button
                className="header-button"
                variant="text"
                onClick={() => navigate("/tutor-panel/lesson-plan/create")}
              >
                <p className="page-header-button-text">Create lession plan</p>
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Search by title</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by title"
                />
              </div>
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={2} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-header">
            <p className="table-heading">lesson plan</p>
          </div>
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="lesson-plan-table-id-heading">ID</th>
                <th className="lesson-plan-table-date-heading">Date</th>
                <th className="lesson-plan-table-subject-name-heading">
                  Subject Name
                </th>
                <th className="lesson-plan-table-topic-heading">Topic</th>
                <th className="lesson-plan-table-topic-description-heading">
                  Topic Discription
                </th>
                <th className="lesson-plan-table-time-heading">Time</th>
                <th className="lesson-plan-table-action-heading"></th>
                <th className="lesson-plan-table-share-heading"></th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-id-data">{tableIndex + 1}</td>
                    <td className="table-data">{tableValue.date}</td>
                    <td className="table-data">{tableValue.subjectName}</td>
                    <td className="table-data">{tableValue.topic}</td>
                    <td className="table-data">
                      {tableValue.topicDescription}
                    </td>
                    <td className="table-data">{tableValue.time}</td>
                    <td className="table-data">
                      <select className="table-action-dropdown">
                        <option value="">Action</option>
                        <option value="View">View</option>
                        <option value="Edit">Edit</option>
                        <option value="Delete">Delete</option>
                      </select>
                    </td>
                    <td className="table-data">
                      <Button
                        className="lesson-plan-table-share-button"
                        onClick={() => setShareModel(true)}
                      >
                        <ShareIcon color="#303030" />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>

      <Model
        modelTitle="Share students"
        width="md"
        onClose={() => setShareModel(false)}
        open={shareModel}
        buttonTitle="Share"
        buttonHandler={ShareHandler}
        loading={shareLoading}
      >
        <div className="form-container">
          <div className="lesson-panel-model-header">
            <p className="lesson-panel-model-header-heading">Select All</p>
            <Checkbox
              {...label}
              defaultChecked
              sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
            />
          </div>
          {shareList.map((shareListValue, shareListIndex) => {
            return (
              <div
                className="lesson-panel-model-user-list-main"
                key={shareListIndex}
              >
                <div className="lesson-panel-model-user-data">
                  <img
                    src={ProfileImage}
                    className="lesson-panel-model-user-profile"
                  />
                  <p className="lesson-panel-model-user-name">
                    {shareListValue.name}
                  </p>
                </div>
                <Checkbox
                  {...label}
                  checked={shareListValue.select}
                  onChange={() => {
                    shareList[shareListIndex].select =
                      !shareList[shareListIndex].select;
                    setShareList([...shareList]);
                  }}
                  sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                />
              </div>
            );
          })}
        </div>
      </Model>
    </SideMenu>
  );
};
export default LessonPlan;
